import { CoordinatorService } from './coordinator.service';
import { Publication } from './publication';
import { ScriptInput } from './script-input';
import { Story } from './story';
import { Report } from './report';
import { Script } from './script';
import { ScriptHub } from './script-hub';

export class Hub$ {
    private _memowlProjectMap?: Map<string, Publication>;
    private _scriptHub: ScriptHub;

    constructor(public coords: CoordinatorService) {
        this._scriptHub = new ScriptHub(this.coords);
    }

    start() {
        this.coords.isHub = true;
    }

    get script() {
        return this._scriptHub;
    }

    publishDialog(target: Story | Report) {
        this.coords.display$.dialog$.next({
            action: 'hub-publish',
            target: target,
        });
    }

    async publish({
        target,
        description,
    }: {
        target: Story | Report | Script;
        description?: string;
    }) {
        const blob = await target.hubExport();
        if (!blob) {
            alert('Failed to publish the script.');
            return;
        }

        let type = 'report';
        if (target instanceof Report) type = 'repor';
        else if (target instanceof Story) type = 'story';
        else if (target instanceof Script) type = 'script';

        const respPublish = await this.coords.firebase$.callFunction('publishReport', {
            id: this.coords.uniqueId(),
            sourceId: this.coords.project$.currentId,
            title: target.title,
            description: description || '',
            type: type,
            payload: Array.from(new Uint8Array(await blob.arrayBuffer())),
        });

        if (respPublish === 'ERROR' || !(respPublish as any).data.isPublished) {
            console.error('Error saving report to Hub:', respPublish);
            return;
        }

        this.coords.display$.closeDialog();
    }

    async currentUserLs() {
        const respLs = await this.coords.firebase$.callFunction('publicationLs', {
            userId: this.coords.user$.currentId,
        });
        if (respLs === 'ERROR') return [];
        return (respLs.data as any[]).map((x) => new Publication(this.coords, x));
    }

    get memowlLs() {
        if (!this._memowlProjectMap) return [];
        return Array.from(this._memowlProjectMap!.values());
    }

    async downloadMemowlProjectLs() {
        if (!this._memowlProjectMap) {
            this._memowlProjectMap = new Map();
            const ls = await this.coords.firebase$.firestore.getObjectLs('hub', {
                field: 'ownerId',
                value: '_memowl',
            });
            ls.forEach((x: any) => {
                const p = new Publication(this.coords, x);
                this._memowlProjectMap!.set(p.id, p);
            });
            this.coords.display$.markForCheck();
        }
    }

    async openMemowl(publ: Publication) {
        // console.log('openMemowl', publ);
        if (publ.type === 'report') {
            const resp = this.coords.firebase$.storage.downloadZipFile({
                remotePath: publ.storagePath,
                type: 'report-project',
                isHub: true,
                openAs: publ.openAs,
                scriptLs: publ.scriptLs,
            });
            // console.log('resp', resp);
        }
    }

    async open(publ: Publication | string) {
        this.coords.display$.dialog$.next({
            action: 'message',
            origin: this,
            message: this.coords.text('openingHubProject'),
        });
        let publicationId: string;

        if (publ instanceof Publication) {
            if (publ.isMemowl) return this.openMemowl(publ);
            publicationId = publ.id;
        } else publicationId = publ;

        let publId = publ;
        if (publ instanceof Publication) publId = publ.id;
        const resp = await this.coords.firebase$.storage.downloadFile2(`/hub/${publId}`);
        console.log('open resp', resp);
        if (!resp) return;
        const inp = new ScriptInput(this.coords);
        await inp.process(resp);
        await inp.asNew();
        this.coords.isHub = false;
    }
}
